
let interval3 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    let avpoAccordionMultipleItems = document.querySelectorAll(".avpo-accordion-multiple-item .avp-paragraph h2");
    let avpoAccordionOptionItems = document.querySelectorAll(".avpo-accordion-multiple-item .avp-paragraph p");
    
    for(let i=0; i<avpoAccordionMultipleItems.length; i++) {
      let checkExist = avpoAccordionOptionItems[i].parentNode.querySelector(".avpo-accordion-item");
      $(avpoAccordionMultipleItems[i]).click(function() {
        if(!checkExist) {
          avpoAccordionOptionItems[i].classList.add('avpo-accordion-item');       
        } 
        if(checkExist) {
          avpoAccordionOptionItems[i].removeAttribute("class");
        }
      });
    }
  }
}, 100);